import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { getMonthName } from "../General/Utility";

const fmtAmount = (n) =>
  Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

const ConcessionReportDetail = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOfStudents, setListOfStudents] = useState([]);
  const [ruleName, setRuleName] = useState("");
  const [totals, setTotals] = useState({ gross: 0, concession: 0, net: 0 });

  const urlParams = new URLSearchParams(window.location.search);
  const ReportYear = urlParams.get("ReportYear");
  const ReportMonth = urlParams.get("ReportMonth");
  const ConcessionRuleID = urlParams.get("ConcessionRuleID");
  const ConcessionCode = urlParams.get("ConcessionCode") || "";
  const wingId = urlParams.get("Wing_Id") || "0";
  const classId = urlParams.get("Class_Id") || "0";
  const sectionId = urlParams.get("Section_Id") || "0";
  const sessionId = urlParams.get("SessionID") || "0";
  const ruleTitle = urlParams.get("RuleName") || "";

  useEffect(() => {
    document.title = "Concession Report Detail";

    if (!ReportYear || !ReportMonth || !ConcessionRuleID) {
      setLoading(false);
      return;
    }

    setRuleName(ruleTitle);
    setLoading(true);

    axios({
      method: "post",
      url: config.base_url + "/Reports/GetConcessionReportDetail",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ReportYear,
        ReportMonth,
        Concession_Rule_ID: Number(ConcessionRuleID) || 0,
        FeeCode: ConcessionCode,
        Title: ruleTitle,
        Wing_Id: Number(wingId) || 0,
        Class_Id: Number(classId) || 0,
        Section_Id: Number(sectionId) || 0,
        SessionID: Number(sessionId) || 0,
        pageSize: 10000,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfStudents(response.data.ListofRecords || []);
          setRuleName(
            response.data.Concession_Rule_Name || ruleTitle || ""
          );
          setTotals({
            gross: response.data.TotalGrossFee ?? 0,
            concession: response.data.TotalConcession ?? 0,
            net: response.data.TotalNetFee ?? 0,
          });
        } else {
          setListOfStudents([]);
        }
        setLoading(false);
      })
      .catch(function () {
        setListOfStudents([]);
        setLoading(false);
      });
  }, []);

  const title = `Concession Detail — ${ruleName} (${getMonthName(ReportMonth)} ${ReportYear})`;

  return (
    <Page orientation="landscape" size="a4">
      <PrintHeader title={title} />
      <table className="table table-sm table-bordered table-print">
        <thead>
          <tr>
            <th>Sr#</th>
            <th>Registration No</th>
            <th>Student Name</th>
            <th>Class</th>
            <th>Section</th>
            <th className="text-end">Gross Fee</th>
            <th className="text-end">Concession</th>
            <th className="text-end">Net Fee</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan={8}>
                <Spinner animation="border" size="sm" />
              </td>
            </tr>
          ) : listOfStudents.length > 0 ? (
            <>
              {listOfStudents.map((item, index) => (
                <tr key={`${item.Student_ID}-${index}`}>
                  <td>{item.Serial_No}</td>
                  <td>{item.Registration_No}</td>
                  <td>{item.Student_Name}</td>
                  <td>{item.Class_Name}</td>
                  <td>{item.Section_Name}</td>
                  <td className="text-end">{fmtAmount(item.GrossFee)}</td>
                  <td className="text-end">{fmtAmount(item.ConcessionAmount)}</td>
                  <td className="text-end">{fmtAmount(item.NetFee)}</td>
                </tr>
              ))}
              <tr className="fw-semibold">
                <th colSpan={5} className="text-end">
                  Total ({listOfStudents.length} students)
                </th>
                <th className="text-end">{fmtAmount(totals.gross)}</th>
                <th className="text-end">{fmtAmount(totals.concession)}</th>
                <th className="text-end">{fmtAmount(totals.net)}</th>
              </tr>
            </>
          ) : (
            <tr>
              <td colSpan={8}>
                <h4
                  className="mt-3"
                  style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
                >
                  No Data Found
                </h4>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Page>
  );
};

export default ConcessionReportDetail;
